var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { getReq } from "../../request";
import { DELETE_CALENDAR_EVENT } from "../../globals";
import { AppContext } from "../../appContext";
import { getRealTime } from "../../Utils";
var CalendarEvents = function (props) {
    var events = props.events, executeAction = props.executeAction;
    var parentContext = useContext(AppContext);
    var chatPrefs = parentContext.chatPrefs;
    var _a = useState(), executed = _a[0], setExecuted = _a[1];
    var _b = useState(""), showMessage = _b[0], setShowMessage = _b[1];
    var deleteEvent = function (id) {
        if (!executeAction || executed == id)
            return;
        setExecuted(id);
        var wait = getReq(DELETE_CALENDAR_EVENT + "/" + id, {});
        wait
            .then(function (response) {
            console.log(response);
            setShowMessage(response.data);
        })
            .catch(function (err) { return setShowMessage("Unable to cancel your appointment."); });
    };
    return (_jsxs("div", __assign({ className: "orders__collections" }, { children: [_jsx("div", __assign({ className: "orders__collections-order-list", style: { minWidth: "210px" } }, { children: events &&
                    events.length > 0 &&
                    events.map(function (event) {
                        return (_jsxs("div", __assign({ className: "orders__collections-order-list-item ".concat(executeAction ? "select" : "") }, { children: [_jsx("div", __assign({ className: "orders__collections-order-name" }, { children: event.name })), _jsxs("div", __assign({ className: "orders__collections-list-order-header" }, { children: [_jsx("div", __assign({ className: "orders__collections-order-left" }, { children: _jsx("div", __assign({ className: "orders__collections-order-timeago" }, { children: event.start_time && event.end_time && (_jsxs(_Fragment, { children: [getRealTime(event.start_time), " -", " ", getRealTime(event.end_time), _jsx("div", { children: new Date(event.start_time).toLocaleDateString() })] })) })) })), _jsx("button", __assign({ className: "multi_choice-list-item-btn ".concat(event.executed || !executeAction ? "disabled" : ""), onClick: function (e) {
                                                if (event.executed)
                                                    return;
                                                event.executed = true;
                                                deleteEvent(event.id);
                                            } }, { children: executed == event.id && !showMessage
                                                ? "Cancelling..."
                                                : "Cancel" }))] }))] })));
                    }) })), showMessage && (_jsx("div", __assign({ style: { marginTop: "5px", color: chatPrefs.widget.colorCode } }, { children: showMessage })))] })));
};
export default CalendarEvents;
